var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("PortalWidget", { attrs: { widget: _vm.widget } }, [
    _c(
      "div",
      { staticClass: "rtb-stats__widget" },
      [
        _vm.isLoading
          ? _c("LoadingStatusDisplay")
          : !_vm.rateLimitData.length
          ? _c("div", { staticClass: "empty-records" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("RATE_LIMIT_PANE_EMPTY")) + "\n    "
              )
            ])
          : _c("v-table", {
              staticClass: "table_beauty",
              attrs: { data: _vm.rateLimitData, columns: _vm.columns },
              scopedSlots: _vm._u(
                [
                  {
                    key: "head",
                    fn: function() {
                      return [
                        _c("thead", [
                          _c(
                            "tr",
                            _vm._l(_vm.columns, function(col, index) {
                              return _c(
                                "th",
                                {
                                  key: col.key + "_" + index,
                                  class: col.headerClass
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t(col.displayName)) +
                                      "\n            "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "body",
                    fn: function({ displayData }) {
                      return [
                        _c(
                          "tbody",
                          [
                            _vm._l(displayData, function(row, index) {
                              return [
                                _c(
                                  "tr",
                                  {
                                    key: "main_" + index,
                                    class: [
                                      "main-row",
                                      _vm.getRowClass(row, index, displayData),
                                      { selected: _vm.expandedRow === index }
                                    ],
                                    attrs: {
                                      "aria-expanded": _vm.expandedRow === index
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.toggleDetails(index)
                                      },
                                      keydown: [
                                        function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          return _vm.toggleDetails(index)
                                        },
                                        function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "space",
                                              32,
                                              $event.key,
                                              [" ", "Spacebar"]
                                            )
                                          )
                                            return null
                                          return _vm.toggleDetails(index)
                                        }
                                      ]
                                    }
                                  },
                                  _vm._l(_vm.columns, function(col, colIndex) {
                                    return _c(
                                      "td",
                                      {
                                        key:
                                          col.key +
                                          "_" +
                                          colIndex +
                                          "_" +
                                          index,
                                        class: col.cellClass
                                      },
                                      [
                                        colIndex === 0
                                          ? _c("span", {
                                              staticClass: "caret",
                                              class: {
                                                up: _vm.expandedRow === index
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm._t(
                                          _vm.$scopedSlots[
                                            `col:${colIndex + 1}`
                                          ]
                                            ? `col:${colIndex + 1}`
                                            : "cell",
                                          function() {
                                            return [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    col.valueFormatter
                                                      ? col.valueFormatter({
                                                          value: row[col.key]
                                                        })
                                                      : row[col.key]
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          },
                                          null,
                                          {
                                            row,
                                            index,
                                            col,
                                            colIndex,
                                            value: col.valueFormatter
                                              ? col.valueFormatter({
                                                  value: row[col.key]
                                                })
                                              : row[col.key]
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _vm.expandedRow === index
                                  ? _c(
                                      "tr",
                                      {
                                        key: "expanded_" + index,
                                        staticClass: "expanded-row noHover"
                                      },
                                      [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "expanded-content no-padding",
                                            attrs: {
                                              colspan: _vm.columns.length
                                            }
                                          },
                                          [
                                            _c("v-table", {
                                              staticClass: "table_beauty",
                                              attrs: {
                                                data: _vm.extraData,
                                                columns: _vm.extraColumns
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "head",
                                                    fn: function() {
                                                      return [
                                                        _c("thead", [
                                                          _c(
                                                            "tr",
                                                            _vm._l(
                                                              _vm.extraColumns,
                                                              function(
                                                                col,
                                                                extraColIndex
                                                              ) {
                                                                return _c(
                                                                  "th",
                                                                  {
                                                                    key:
                                                                      col.key +
                                                                      "_" +
                                                                      extraColIndex +
                                                                      "_extraData",
                                                                    class:
                                                                      col.headerClass
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            col.displayName
                                                                          )
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        ])
                                                      ]
                                                    },
                                                    proxy: true
                                                  },
                                                  {
                                                    key: "body",
                                                    fn: function({
                                                      displayData: extraDisplayData
                                                    }) {
                                                      return [
                                                        _c(
                                                          "tbody",
                                                          _vm._l(
                                                            extraDisplayData,
                                                            function(
                                                              extraRow,
                                                              extraIndex
                                                            ) {
                                                              return _c(
                                                                "tr",
                                                                {
                                                                  key:
                                                                    extraIndex +
                                                                    "_extraData"
                                                                },
                                                                _vm._l(
                                                                  _vm.extraColumns,
                                                                  function(
                                                                    col,
                                                                    colIndex
                                                                  ) {
                                                                    return _c(
                                                                      "td",
                                                                      {
                                                                        key:
                                                                          col.key +
                                                                          "_" +
                                                                          colIndex +
                                                                          "_" +
                                                                          extraIndex +
                                                                          "_extraData",
                                                                        class:
                                                                          col.cellClass,
                                                                        staticStyle: {
                                                                          "white-space":
                                                                            "nowrap"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                          " +
                                                                            _vm._s(
                                                                              col.valueFormatter
                                                                                ? col.valueFormatter(
                                                                                    {
                                                                                      value:
                                                                                        extraRow[
                                                                                          col
                                                                                            .key
                                                                                        ]
                                                                                    }
                                                                                  )
                                                                                : extraRow[
                                                                                    col
                                                                                      .key
                                                                                  ]
                                                                            ) +
                                                                            "\n                        "
                                                                        )
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            })
                          ],
                          2
                        )
                      ]
                    }
                  }
                ],
                null,
                true
              )
            })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }